module.exports = __webpack_public_path__ + "img/planet.7c0125e7.svg";